module.exports = __webpack_public_path__ + "img/ca.64588f1c.png";